import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type intervalData } from '../services/getFlameSignaGraphDataService'
export interface flameSignalReadingAssetDataState {
  isLoading: boolean
  errorMessage: string | null
  flameSignalReadingData: intervalData | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flameSignalReadingAssetDataState = {
  flameSignalReadingData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flameSignalDataState = createSlice({
  name: 'flameSignalData',
  initialState,
  reducers: {
    flameSignalDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flameSignalReadingData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flameSignalDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        flameSignalReadingData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flameSignalDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flameSignalReadingData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flameSignalDataLoadingAction,
  flameSignalDataUpdateAction,
  flameSignalDataErrorAction
} = flameSignalDataState.actions

export default flameSignalDataState.reducer
